export const ADAPTIVE_SIZE_GRIP_BREAKPOINT = '(max-width: 1024px)';

export enum ScaleSetValues {
  Local = 0,
  Us = 1,
}

export const SCALE_SET_TRANSLATIONS = {
  [ScaleSetValues.Local]: $localize`:ConfigStrip|Scale Set Selector Local Values@@scaleSetValuesLocal:Local`,
  [ScaleSetValues.Us]: $localize`:ConfigStrip|Scale Set Selector Us Values@@scaleSetValuesUs:US`,
};
